// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner___2Vq7","spin":"styles_spin__W8Iub"};